import Navbar from "@/components/Navbar";
import Slideshow from "@/components/SlideShow";

import Footer from "@/components/Footer";
import CategoryGrid from "@/components/CategoryGrid";
import classes from "./Home.module.css";
import Items from "@/components/Items";
import Discount from "@/components/Discounts";


export default function Home() {
  return (
    <div className={classes.main}>
      <Navbar />
      <div className="mt-10 mb-10">
        <Slideshow />
      </div>
      <div>
        <Items text="پیشنهادات" link="suggestions"/>
      </div>
      <div className="mt-10 mb-10">
        <Discount />
      </div>
      <div className="mt-10 mb-10">
        <CategoryGrid/>
      </div>
      <div className="mt-10 mb-10">
        <Items text="جدیدترین ها" link="newproducts" />
      </div>
      <div className="mt-10 ">
        <Footer />
      </div>
    </div>
  );
}
